import { Card, CardHeader } from "@mui/material";
import useLocales from "src/hooks/useLocales";

import Context from "./context";
import FundsTable from "./FundsTable/FundsTable";
import useUnknownFundsStore from "./store";

// ----------------------------------------------------------------------

export const UnknownFunds = () => {
	const [state, actions] = useUnknownFundsStore();
	const { translate } = useLocales();

	return (
		<Context.Provider value={{ state, actions }}>
			<Card sx={{ mt: 4 }}>
				<CardHeader sx={{ pb: 2.25 }} title={translate("Gestión fondos desconocidos")} />
				<FundsTable />
			</Card>
		</Context.Provider>
	);
};

export default UnknownFunds;
